module.exports = __webpack_public_path__ + "img/pexels-pixabay-315755.32b67c72.jpg";